import { ofbiz } from './http';

export function getReportMonitorLogs(query = {}) {
  const { from = 0, size = 10000, ...rest } = query;
  return ofbiz.post('report/monitorLogs', null, { ...rest, from, size });
}

export function getReportStatusReport(query = {}) {
  return ofbiz.post('report/statusReport', null, query);
}

export function getReportAllStatusReport(query = {}) {
  return ofbiz.post('report/allStatusReport', null, query);
}

export function getReportTopNReport(query = {}) {
  return ofbiz.post('report/topNReport', null, query);
}

export function getReportStatisticsReport(query = {}) {
  return ofbiz.post('report/statisticsReport', null, query);
}

export function getReportList(query = {}, page = 1, pageSize = 500) {
  return ofbiz.postPage('report/list', query, page, pageSize);
}

export function getReportById(reportId) {
  return ofbiz.post('report/getById', null, { reportId });
}

export function createReport(data) {
  return ofbiz.post('report/create', data);
}

export function updateReport(data) {
  return ofbiz.post('report/update', data);
}

export function deleteReport(reportId) {
  return ofbiz.post('report/delete', null, { reportId });
}

export function toggleReportStatus(reportId) {
  return ofbiz.post('report/toggleStatus', null, { reportId });
}

export function getReportMonitors(reportId) {
  return ofbiz.post('report/getMonitors', null, { reportId });
}

export function assignReportMonitors(reportId, monitorIds) {
  const ids = Array.isArray(monitorIds) ? monitorIds.join(',') : monitorIds;
  return ofbiz.post('report/assignMonitors', null, { reportId, monitorIds: ids || '' });
}

// ======== 报表文件生成/列表/删除/导出（对应老版 ReportFiles BO） ========

/** 手动生成报表（对齐老版 rest/report/create 的 id/reporttype 参数语义） */
export function generateReport(reportId, reporttype) {
  return ofbiz.post('report/generateReport', null, { id: reportId, reporttype });
}

/** 查询报表配置下已生成的文件记录列表 */
export function getReportFiles(reportId) {
  return ofbiz.post('report/files', null, { reportId });
}

/** 删除单条已生成文件记录（含物理文件） */
export function deleteReportFile(fileId) {
  return ofbiz.post('report/deleteFile', null, { fileId });
}

// 下载基址：报表文件下载路由挂在 /itoss/control/ 下（无 json 前缀）
const CONTROL_BASE = ofbiz.baseURL.replace(/\/control\/json\/$/, '/control/');

/** 批量导出选中的已生成文件，返回可直接触发下载的完整 URL（zip） */
export function exportOtherReports(ids) {
  const idArr = Array.isArray(ids) ? ids : [ids];
  return ofbiz.post('report/exportOther', { ids: idArr }).then((data) => {
    const rel = data && data.url;
    if (!rel) return '';
    return CONTROL_BASE + (rel.charAt(0) === '/' ? rel.substring(1) : rel);
  });
}
